// Recordatorio de saldo a favor: llamadas al backend y los textos que comparten la pantalla
// Clientes → Saldos a favor y el botón del detalle del cliente.
//
// Las fechas llegan del backend como hora de pared de Montevideo ('YYYY-MM-DD HH:mm:ss'), ya
// convertidas. Se formatean partiendo el string: pasarlas por `new Date()` las reinterpretaría
// en la zona del navegador.

import { get, post } from './apiClient';

export const listarSaldos = () => get('store-credit');
export const recordarATodos = (incluirRecientes) => post('store-credit/reminders', { incluirRecientes: Boolean(incluirRecientes) });
export const estadoRecordatorio = (cedula) => get(`store-credit/${encodeURIComponent(cedula)}/reminder`);
export const recordarSaldo = (cedula, forzar) => post(`store-credit/${encodeURIComponent(cedula)}/reminder`, { forzar: Boolean(forzar) });

// El backend responde 3205 cuando ya se le recordó hace menos de 30 días; trae la fecha en data.
export const YA_RECORDADO = 3205;

export function fechaCorta(wall) {
    const m = String(wall || '').match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (!m) return '';
    return `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}`;
}

export function pesos(value) {
    const n = Number(value || 0);
    return `$ ${n.toLocaleString('es-UY', { maximumFractionDigits: 2 })}`;
}

const MOTIVOS = {
    sin_mail: 'Sin mail',
    invalido: 'Mail inválido',
    sospechoso: 'Mail con tipeo',
};

// Por qué no se le manda el recordatorio a este cliente; null si se le puede escribir.
export function motivoNoEnvio(mail) {
    if (!mail || mail.enviable) return null;
    return MOTIVOS[mail.motivo] || 'Mail a revisar';
}

// "Último recordatorio" en una línea. Un intento fallido se dice como fallido: no es un
// recordatorio hecho.
export function textoUltimoRecordatorio(recordatorio) {
    const r = recordatorio || {};
    if (!r.ultimo) return 'Nunca';
    const { ultimo, ultimoEnviado } = r;
    if (ultimo.estado === 'SENT') return fechaCorta(ultimo.fecha);
    const fallo = ultimo.estado === 'FAILED' ? `Falló el ${fechaCorta(ultimo.fecha)}` : `No se envió el ${fechaCorta(ultimo.fecha)}`;
    return ultimoEnviado ? `${fallo} (el último salió el ${fechaCorta(ultimoEnviado.fecha)})` : fallo;
}

// Cuenta lo que va a pasar al tocar "Recordar saldo a todos", para la confirmación.
export function resumenEnvio(clientes, incluirRecientes) {
    const r = { aEnviar: 0, sinMail: 0, aRevisar: 0, recientes: 0 };
    (clientes || []).forEach((c) => {
        if (!c.mail || !c.mail.enviable) {
            if (c.mail && c.mail.motivo === 'sin_mail') r.sinMail += 1; else r.aRevisar += 1;
            return;
        }
        if (c.recordatorio && c.recordatorio.reciente) {
            r.recientes += 1;
            if (!incluirRecientes) return;
        }
        r.aEnviar += 1;
    });
    return r;
}

// Aplica a la lista lo que devolvió un envío, sin volver a pedirla: el backend registra el
// envío en su log sin esperar, así que releer en el acto puede no traer todavía el último.
export function aplicarResultados(clientes, resultados) {
    const porCedula = new Map((resultados || []).map((r) => [String(r.cedula), r]));
    return (clientes || []).map((c) => {
        const r = porCedula.get(String(c.cedula));
        if (!r) return c;
        const intento = { fecha: r.fecha, estado: r.estado === 'enviado' ? 'SENT' : (r.estado === 'fallo' ? 'FAILED' : 'SKIPPED'), mail: r.email };
        const previo = c.recordatorio || {};
        return {
            ...c,
            recordatorio: intento.estado === 'SENT'
                ? { ultimo: intento, ultimoEnviado: intento, reciente: true }
                : { ...previo, ultimo: intento },
        };
    });
}

// "Último recordatorio" al lado del botón general, después de un envío: el último que salió.
export function ultimoEnvioTras(ultimoEnvio, resultados) {
    const enviados = (resultados || []).filter((r) => r.estado === 'enviado' && r.fecha).map((r) => r.fecha);
    // Las fechas son 'YYYY-MM-DD HH:mm:ss': el orden de texto es el orden de tiempo.
    return [ultimoEnvio, ...enviados].filter(Boolean).sort().pop() || null;
}
